import React, { useEffect, useState, useRef } from "react";
import ButtonSKA from "../Buttons/ButtonSKA";
import strings from "../../helpers/Localization";
import Inputs from "../Inputs/Inputs";
import IconComponent from "../Icons/IconComponent";
import ButtonSkaRound from "../Buttons/ButtonSkaRound";
import Toggle from "../Inputs/Toggle";
import VideoPlayer from "../VideoPlayer/VideoPlayer";
import Lottie from "../../components/Lottie";

const VideoModal = ({
    videosrc,
    open,
    hide,
    onClose,
    fields,
    style,
    isValidationRed,
    validationTitle,
    validationIcon,
    onValidate,
    disableValidate,
    children
}) => {

    const videoPlayerRef = useRef(null);
    const LottieRef = useRef(null);
    const audioPlayingLottieAnimation = "/animationsLottie/audio-message-playing.json";
    const [isVideo, setIsVideo] = useState(true);

    useEffect(() => {
        if (!videosrc) {return;}

        const video = document.createElement("video");
        video.src = videosrc;
        video.preload = "metadata";

        const handleLoaded = () => {
            // If no video with and no video height => No video track
            const hasVideoTrack = video.videoWidth > 0 && video.videoHeight > 0;
            setIsVideo(hasVideoTrack);
        };

        video.addEventListener("loadedmetadata", handleLoaded);
        return () => video.removeEventListener("loadedmetadata", handleLoaded);
    }, [videosrc]);

    let canSave = true;

    // if the object can be named, it must be so.
    if (fields) {
        const name = fields.find(f => f.type === "textfield" && f.title === strings.name);
        if (name !== undefined && (name.value === undefined || name.value === "" || name.value === null)) {
            canSave = false;
        }
    }
    if (disableValidate) {canSave = false;}

    if (!open) {
        return null;
    }

    if (open) {
        return <div className="modal" style={{ visibility: hide ? "hidden" : "visible", width: style && style.width ? style.width : null, height: style && style.height ? style.height : null }}>
            <div className="modal-black-box"/>
            <div className="modal-container">
                <div className="modal-paper" style={{ maxWidth: "calc(100% - 40px)", width: "1200px" }}>
                    <div className="modal-body" style={{ height: "500px", width: "100%", flexDirection: "row", gap: "0px", padding: "0px" }}>
                        <div style={{ display: "flex", width: "310px", height: "calc(100% - 40px)", gap: "20px",
                            padding: "20px", flexDirection: "column", overflowY: "scroll" }}>
                            {fields ? fields.map((item, index) => {
                                if (item) {
                                    return <Inputs field={item} key={index}/>;
                                }
                            }) : null}
                            {children}
                        </div>
                        <div style={{ display: "flex", flexGrow: 1, height: "100%", backgroundColor: isVideo ? "black" : "white" }}>
                            {videosrc ?
                                isVideo ?
                                    <VideoPlayer
                                        showSlider={true}
                                        src={videosrc}
                                        canTrackProgress={true}
                                        ref={videoPlayerRef}
                                        onEnded={() => {}}
                                        muteVideo={false}
                                    />
                                    :
                                    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Lottie ref={LottieRef} animation={audioPlayingLottieAnimation} durationSeconds={60} autoPlay={true} heightLottie={"300px"} />
                                        <audio src={videosrc} autoPlay style={{ width: "100%" }} onEnded={() => LottieRef.current.stopLottie()} />
                                    </div>

                                : null}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <span style={{ flexGrow: "1", flexShrink: "0" }}/>
                        {
                            onValidate ?
                                <ButtonSKA
                                    type={isValidationRed ? "red" : "secondary-icon"}
                                    isDisabled={!canSave}
                                    onClick={onValidate}
                                    nameIcon={validationIcon ? validationIcon : "check"}
                                    text={validationTitle ? validationTitle : strings.startSearch}
                                /> : null}
                        <ButtonSKA
                            type={"primary-icon"}
                            onClick={onClose}
                            nameIcon={"cancel"}
                            text={strings.Close}
                        />
                    </div>
                </div>
            </div>
        </div>;
    }
};

export default VideoModal;
